import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-primary-600 text-sm font-medium tracking-wider mb-3">
            探索内容
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            五大文化维度
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm leading-relaxed">
            从不同角度深入草灯和尚的禅意世界，感受东方文化的深厚底蕴
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-lg border border-secondary-200/70 bg-background-50 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 text-center"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}